module.exports = __webpack_public_path__ + "img/DanielZeichnung5.6d6ebf56.svg";